import { t } from "@/i18n-js/instance";
import reviewLogos from "@circle-assets/images/onboarding/review-logos.svg";
import { Typography } from "@circle-react/components/shared/uikit/Typography";

const LOCALE_SCOPE = "authentication_app.new_onboarding_flow_april_2025";

export const ReviewStats = () => (
  <div className="flex flex-col items-center space-y-4">
    <div className="relative flex items-center space-x-2 rounded-full border border-white/10 px-3 py-2 pl-14">
      <img
        src={reviewLogos}
        loading="lazy"
        alt=""
        className="absolute left-2 top-1/2 h-12 w-12 -translate-y-1/2"
      />
      <div className="flex">
        {Array.from({ length: 5 }).map((_, i) => (
          <svg
            key={i}
            className="h-5 w-5 text-yellow-400"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
      <div className="opacity-80">
        <Typography.LabelMd color="text-white">
          {t(`${LOCALE_SCOPE}.reviews`)}
        </Typography.LabelMd>
      </div>
    </div>
  </div>
);
